import type { ReactNode } from "react";

export type ConcreteDayDefinition = new (
	language: "EN" | "FR",
) => DayDefinition;

/** Provides the title, content, colour, etc. for a card. */
export abstract class DayDefinition {
	/** The CSS class to use for the card. */
	public abstract className: string;
	/** The content to display for the card. */
	public content: ReactNode;
	public abstract image: string;
	/** The languages supported by the card. */
	public languages = ["en", "fr"];
	/** The slug for the card. Used to identify the card for css, etc. */
	public abstract slug: string;
	/** The title to display for the card. */
	public title: string = "";

	/**
	 * The language to display the card in.
	 *
	 * @param language The language to display the card in.
	 */
	public constructor(protected language: "EN" | "FR") {
		this.language = language;
		if (language === "EN") {
			this.initENCard();
		} else {
			this.initFRCard();
		}
	}

	/** Sets the title and content for the card (with English content). */
	public abstract initENCard(): void;

	/** Gets the display object for the card (with French content). */
	public abstract initFRCard(): void;
}
